/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios';
import store from '@/store/';
import router from '@/router/';
import { serialize, deepFilterEmptyParams } from '@/utils/util';
import { setStore, getStore, removeStore } from 'utils/store';
import { getToken, removeToken, removeRefreshToken } from '@/utils/auth';
import { isURL, validatenull } from '@/utils/validate';
import { ElMessage } from 'element-plus';
import website from '@/config/website';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { Base64 } from 'js-base64';
import { baseUrl } from '@/config/env';
import crypto from '@/utils/crypto';
import { Lang, getPrimaryLanguage } from '@/lang/lang.js';

// 全局未授权错误提示状态，只提示一次
let isErrorShown = false;

axios.defaults.timeout = 1000*30;
//返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500; // 默认的
};
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
// NProgress Configuration
NProgress.configure({
  showSpinner: false,
});

function removeTokenAndExit() {
  // 清除token信息
  removeToken();
  removeRefreshToken();
  removeStore({ name: 'token' });
  // 重定向到登录页
  if (/\/login/g.test(location.pathname)) {
    console.log(46)
    location.href = location.href;
  } else {
    location.reload()
  }
}
//http request拦截
axios.interceptors.request.use(
  config => {
    // start progress bar
    NProgress.start();
    // 初始化错误提示状态
    isErrorShown = false;
    //地址为已经配置状态则不添加前缀
    if (!isURL(config.url) && !config.url.startsWith(baseUrl)) {
      config.url = baseUrl + config.url;
    }
    //安全请求header
    config.headers['Blade-Requested-With'] = 'BladeHttpRequest';
    // 语言定义
    config.headers['Accept-Language'] = config.headers.AcceptLanguage || sessionStorage.getItem('language') || getPrimaryLanguage() || import.meta.env.VITE_APP_LANGUAGE;
    config.headers['Tenat-Id'] = getStore({ name: 'tenantId' }) || '';
    //headers判断是否需要
    const authorization = config.authorization === false;
    if (!authorization) {
      config.headers['Authorization'] = `Basic ${Base64.encode(
        `${website.clientId}:${website.clientSecret}`
      )}`;
    }
    //headers判断请求是否携带token
    const meta = config.meta || {};
    const isToken = meta.isToken === false;
    //headers传递token是否加密
    const cryptoToken = config.cryptoToken === true;
    // 判断是否过滤为空的传输参数, 非全站过滤，需在单个request接口里配置。
    const filterEmptyParams = config.filterEmptyParams === true;
    //判断传递数据是否加密
    const cryptoData = config.cryptoData === true;
    const token = getToken();
    if (token && !isToken) {
      config.headers[website.tokenHeader] = cryptoToken
        ? 'crypto ' + crypto.encryptAES(token, crypto.cryptoKey)
        : 'bearer ' + token;
    }
    // 开启过滤参数，支持个别接口跳过过滤
    if (filterEmptyParams) {
      if (config.params) {
        config.params = deepFilterEmptyParams(config.params);
      }
      if (config.data) {
        config.data = deepFilterEmptyParams(config.data);
      }
    }
    if (config.params && config.params.AcceptLanguage) {
      config.headers['Accept-Language'] = config.params.AcceptLanguage;
      config.paramsSerializer = params => {
        return serialize(params, { indexes: false });
      };
    }
    // 开启报文加密
    if (cryptoData) {
      if (config.params) {
        const data = crypto.encryptAES(JSON.stringify(config.params), crypto.aesKey);
        config.params = { data };
      }
      if (config.data) {
        config.text = true;
        config.data = crypto.encryptAES(JSON.stringify(config.data), crypto.aesKey);
      }
    }
    //headers中配置text请求
    if (config.text === true) {
      config.headers['Content-Type'] = 'text/plain';
    }
    //headers中配置serialize为true开启序列化
    if (config.method === 'post' && meta.isSerialize === true) {
      config.data = serialize(config.data);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
//http response拦截
axios.interceptors.response.use(
  res => {
    NProgress.done();
    const status = res.status;
    const code = res.data.error_code || res.data.code;
    const statusWhiteList = website.statusWhiteList || [];
    const message = res.data.msg || res.data.error_description || '';
    const config = res.config;
    const cryptoData = config.cryptoData === true;
    //如果在白名单里则自行catch逻辑处理
    if (statusWhiteList.includes(status)) return Promise.reject(res);
    // 如果是401并且没有重试过，尝试刷新token
    const enableRefreshToken = false; // 是否停止刷新token 大屏时设置为true
    config._retry = true;
    if (status === 401 && !config._retry && enableRefreshToken) {
      // 标记此请求已尝试刷新token
      // 调用RefreshToken action来刷新token
      return store
        .dispatch('RefreshToken')
        .then(() => {
          const meta = config.meta || {};
          const isToken = meta.isToken === false;
          const cryptoToken = config.cryptoToken === true;
          // 获取刷新后的token
          const token = getToken();
          if (token && !isToken) {
            config.headers[website.tokenHeader] = cryptoToken
              ? 'crypto ' + crypto.encryptAES(token, crypto.cryptoKey)
              : 'bearer ' + token;
          }
          // 重新发送原来的请求
          return axios(config);
        })
        .catch(() => {
          // 首次报错时提示
          if (!isErrorShown) {
            isErrorShown = true;
            setTimeout(() => {
              isErrorShown = false;
            }, 200)
            ElMessage({
              message: Lang.tips.tokenExpired,
              type: 'error',
            });
          }
          removeTokenAndExit();
          // 这里可以选择是否抛出错误，决定是否继续执行后续的then或catch
          // return Promise.reject(message);
          console.log(178)
          return
        });
    }
    // 如果是401并且已经重试过，直接跳转到登录页面
    if (status === 401 && config._retry) {
      // 首次报错时提示
      if (!isErrorShown) {
        isErrorShown = true;
        setTimeout(() => {
          isErrorShown = false;
        }, 200)
        ElMessage({
          message: res.data.msg,
          type: 'error',
          duration: 2 * 1000,
        });
        console.log(194)
        removeTokenAndExit();
        return
      } else {        
        removeTokenAndExit();
        console.log(199)
        return
      }
      // return Promise.reject(message);
    }
    if (status === 500) {
      // 首次报错时提示
      if (!isErrorShown) {
        isErrorShown = true;
        setTimeout(() => {
          isErrorShown = false;
        }, 200)
        ElMessage({
          message: res.statusText,
          type: 'error',
          duration: 2 * 1000,
        });
        console.log(215)
      }
      return Promise.reject(message);
    }
    // 如果请求为oauth2错误码则首次报错时提示
    if (code > 2000 && !validatenull(res.data.error_description)) {
      // 首次报错时提示
      if (!isErrorShown) {
        isErrorShown = true;
        setTimeout(() => {
          isErrorShown = false;
        }, 200)
        ElMessage({
          message: message,
          type: 'error',
          duration: 2 * 1000,
        });
      }
      return Promise.reject(message);
    }
    
    // 如果请求为非200默认统一处理
    if (code !== 200) {
      if (config.responseType === 'blob') {
        return res;
      }
      if (!isErrorShown) {
        isErrorShown = true;
        setTimeout(() => {
          isErrorShown = false;
        }, 200)
        ElMessage({
          message: message,
          type: 'error',
          duration: 2 * 1000,
        });
      }
      if (code === 401) {
        // 首次报错时提示
        if (!isErrorShown) {
          isErrorShown = true;
          setTimeout(() => {
            isErrorShown = false;
          }, 200)
          ElMessage({
            message: Lang.tips.tokenExpired,
            type: 'error',
          });
          console.log(263)
        }
        console.log(265)
        removeTokenAndExit();
        return
      }
      return Promise.reject(message);
    }
    // 解析加密报文
    if (cryptoData) {
      res.data = JSON.parse(crypto.decryptAES(res.data, crypto.aesKey));
    }
    return res;
  },
  error => {
    NProgress.done();
    return Promise.reject(error);
  }
);

// 通用下载方法
export const download = (option) => {
  const { url, params, method = 'post' } = option
  return axios({
    url: url,
    method: method,
    data: params,
    responseType: 'blob'
  })
    .then(async (res) => {
      const data = res.data
      const filename = res.headers['content-disposition'].split('filename=')[1]
      const isBlob = res.config.responseType === 'blob'
      if (isBlob) {
        const blob = new Blob([data])
        const link = window.document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = decodeURIComponent(filename)
        link.style.display = 'none'
        link.click()
        URL.revokeObjectURL(url)
      } else {
        const resText = await data.text()
        const rspObj = JSON.parse(resText)
        ElMessage.error(rspObj.msg)
      }
    })
    .catch((res) => {
      ElMessage.error(res.msg || Lang.tips.downloadError)
    })
}
export default axios;
